import React from 'react';
import { Stack, Button, Typography } from '@mui/material';
import { YellowMessageBar } from 'components/YellowMessageBar';

export const UnvalidatedSupplierWarning = ({ companyName }) => {
  const handleSendEmail = () => {
    window.location.href = `mailto:hello@delegon.com?subject=Supplier Validation Request - ${companyName}`;
  };

  return (
    <Stack spacing={2} sx={{ mb: 3 }}>
      <YellowMessageBar
        message="Your company is currently unvalidated. You will not be able to create new job advertisements until your company profile has been validated by Delegon. Please contact us to initiate the validation process."
        sx={{ mb: 0 }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSendEmail}
        sx={{ alignSelf: 'center' }}
      >
        Send Validation Request
      </Button>
    </Stack>
  );
};
